import { useState, useEffect } from "react";
import "./style.css";

const DateCounter = ({ fromTo, date = { days: 1, months: 1 }, setDate }) => {
	const { days, months } = date;
	const [inputDays, setInputDays] = useState(days.toString().padStart(2, "0"));
	const [inputMonths, setInputMonths] = useState(months.toString().padStart(2, "0"));

	const increaseDays = () => { setDate((prev) => ({ ...prev, days: prev.days % 31 + 1 })); };
	const decreaseDays = () => { setDate((prev) => ({ ...prev, days: prev.days === 1 ? 31 : prev.days - 1 })); };

	const increaseMonths = () => { setDate((prev) => ({ ...prev, months: prev.months % 12 + 1 })); };
	const decreaseMonths = () => { setDate((prev) => ({ ...prev, months: prev.months === 1 ? 12 : prev.months - 1 })); };

	const handleDaysChange = (e) => {
		let value = e.target.value.replace(/^0+/, ""); // Видаляємо зайві нулі
		if (value === "") {
			setInputDays("");
			return;
		}

		let numValue = Number(value);
		if (!isNaN(numValue) && numValue >= 1 && numValue <= 31) {
			setInputDays(numValue.toString());
			setDate((prev) => ({ ...prev, days: numValue }));
		}
	};

	const handleMonthsChange = (e) => {
		let value = e.target.value.replace(/^0+/, ""); // Видаляємо зайві нулі
		if (value === "") {
			setInputMonths("");
			return;
		}

		let numValue = Number(value);
		if (!isNaN(numValue) && numValue >= 1 && numValue <= 12) {
			setInputMonths(numValue.toString());
			setDate((prev) => ({ ...prev, months: numValue }));
		}
	};

	const handleDaysBlur = () => {
		if (inputDays === "" || Number(inputDays) < 1) {
			setDate((prev) => ({ ...prev, days: 1 }));
			setInputDays("01");
		} else if (Number(inputDays) > 31) {
			setDate((prev) => ({ ...prev, days: 31 }));
			setInputDays("31");
		} else {
			setInputDays(days < 10 ? `0${days}` : days.toString());
		}
	};

	const handleMonthsBlur = () => {
		if (inputMonths === "" || Number(inputMonths) < 1) {
			setDate((prev) => ({ ...prev, months: 1 }));
			setInputMonths("01");
		} else if (Number(inputMonths) > 12) {
			setDate((prev) => ({ ...prev, months: 12 }));
			setInputMonths("12");
		} else {
			setInputMonths(months < 10 ? `0${months}` : months.toString());
		}
	};

	useEffect(() => {
		setInputDays(days < 10 ? `0${days}` : days.toString());
	}, [days]);

	useEffect(() => {
		setInputMonths(months < 10 ? `0${months}` : months.toString());
	}, [months]);

	return (
		<div className="time-counter-wrapper">
			<div className="time-counter">
				<div className="arrows">
					<button className="arrow-button" onClick={increaseDays}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12.8927 11.5423L0.686493 11.5423L6.78962 0.55542L12.8927 11.5423Z" fill="#D5C2B2" />
						</svg>
					</button>
					<button className="arrow-button" onClick={decreaseDays}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.686565 0.0649034L12.8928 0.0649023L6.78969 11.0518L0.686565 0.0649034Z" fill="#D5C2B2" />
						</svg>
					</button>
				</div>
				<div className="time-wrapper">
					<div>
						<input
							className="time-item"
							placeholder="00"
							type="number"
							value={inputDays}
							onChange={handleDaysChange}
							onBlur={handleDaysBlur}
							min="1"
							max="31"
						/>
					</div>
					<div>
						<input
							className="time-item"
							placeholder="00"
							type="number"
							value={inputMonths}
							onChange={handleMonthsChange}
							onBlur={handleMonthsBlur}
							min="1"
							max="12"
						/>
					</div>
				</div>
				<div className="arrows">
					<button className="arrow-button" onClick={increaseMonths}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12.8927 11.5423L0.686493 11.5423L6.78962 0.55542L12.8927 11.5423Z" fill="#D5C2B2" />
						</svg>
					</button>
					<button className="arrow-button" onClick={decreaseMonths}>
						<svg width="18" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.686565 0.0649034L12.8928 0.0649023L6.78969 11.0518L0.686565 0.0649034Z" fill="#D5C2B2" />
						</svg>
					</button>
				</div>
			</div>
			<p className="from-to">{fromTo}</p>
		</div>
	);
};

export default DateCounter;
